module.exports = __webpack_public_path__ + "assets/10bisPlusIcon-c2a7b1.svg";